import {FlexRow, Modal, Text} from '@forecast-it/design-system';
import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {ModalProps} from '../../../forecast-app/shared/components/modals/types';

type PublishQuoteConfirmationModalProps = {
	onConfirm: () => void;
};

export const showPublishQuoteConfirmationModal = (props: PublishQuoteConfirmationModalProps): void => {
	showModal({
		type: MODAL_TYPE.PUBLISH_QUOTE_CONFIRMATION,
		...props,
	});
};

export const PublishQuoteConfirmationModal = ({
	closeModal,
	onConfirm,
}: ModalProps<PublishQuoteConfirmationModalProps>): JSX.Element => {
	const intl = useIntl();

	const handleConfirm = () => {
		onConfirm();
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal} closeOnInteractOutside={false}>
			<Modal.Title>{intl.formatMessage({id: 'quote_designer.publish_modal.title'})}</Modal.Title>
			<Modal.Content>
				<Text>{intl.formatMessage({id: 'quote_designer.publish_modal.body'})}</Text>
				<FlexRow>
					<Modal.PrimaryFooterButton onPress={handleConfirm} dataCy="publish-quote-confirm">
						{intl.formatMessage({id: 'quote_designer.publish_modal.confirm'})}
					</Modal.PrimaryFooterButton>
					<Modal.SecondaryFooterButton onPress={closeModal} dataCy="cancel">
						<FormattedMessage id="common.cancel" />
					</Modal.SecondaryFooterButton>
				</FlexRow>
			</Modal.Content>
		</Modal>
	);
};
